<template>
  <div class="resume-section skills-section" :class="{ 'is-compact': compact }">
    <h2 class="section-heading" :style="headingStyle">Skills</h2>
    <div class="skills-list">
      <span
        v-for="(skill, index) in section.data.items"
        :key="index"
        class="skill-chip"
        :style="{ borderColor: themeColor + '40', color: '#334155' }"
      >
        {{ skill }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#0f766e'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headingStyle() {
      return {
        color: this.themeColor,
        borderColor: this.themeColor,
      }
    }
  }
}
</script>

<style scoped>
.section-heading {
  font-family: var(--ps-font-display);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-bottom: 2px solid;
  padding-bottom: 0.45rem;
  margin-bottom: 1rem;
}

.skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.skill-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.7rem;
  border-radius: 9999px;
  border: 1px solid;
  background: color-mix(in srgb, var(--resume-accent, #0f766e) 8%, #fff);
  font-size: 0.8rem;
  font-weight: 500;
}

.is-compact .skills-list {
  flex-direction: column;
  align-items: flex-start;
}

.is-compact .skill-chip {
  border-radius: 0.4rem;
}
</style>
